module.exports = __webpack_public_path__ + "media/images/products/cards/cripto_research-8fc159b7409a148f1aba4398488a7672.png";